"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Paragraph = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Paragraph = function Paragraph(_ref) {
  var id = _ref.id,
      text = _ref.text;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.StyledParagraph, {
    id: id,
    dangerouslySetInnerHTML: {
      __html: text
    }
  }));
};

exports.Paragraph = Paragraph;